<template>
  <div class="page">
    <header class="page__header">
      <Kvatro_Header />
    </header>
    <b-container>
      <div class="page__body">
        <div
          class="page__navbar"
          v-if="
            isAuthenticated && acceptTime && !displayNavList && mxCanViewGeneral
          "
        >
          <NavigationList />
        </div>
        <SideNavigation />
        <div
          :class="[
            'page__content',
            { 'page__content--transparent': changeBackgroundColor },
            { 'w-100': fullWidth || !mxCanViewGeneral },
          ]"
        >
          <div class="d-md-none">
            <MobileHeader />
          </div>
          <RoleModal v-if="changeRole" />
          <router-view />
          <Cookie v-if="!areCookiesAgreed" />
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import Kvatro_Header from "@/components/Header";
import MobileHeader from "@/components/MobileHeader";
import NavigationList from "@/components/Navigation/NavigationList.vue";
import { mapGetters } from "vuex";
import RoleModal from "@/components/RoleModal/RoleModal";
import SideNavigation from "@/components/Navigation/SideNavigation";
import Cookie from "@/components/Cookie/Cookie";
import { ROUTE_NAMES } from "@/constants/routeConstants";
import Cookies from "js-cookie";

export default {
  name: "BaseLayout",
  components: {
    RoleModal,
    Kvatro_Header,
    MobileHeader,
    NavigationList,
    SideNavigation,
    Cookie,
  },
  computed: {
    ...mapGetters({
      changeRole: "system/changeRole",
      isAuthenticated: "auth/isAuthenticated",
      acceptTime: "user/acceptTime",
    }),
    areCookiesAgreed() {
      return Cookies.get("Cookies");
    },
    displayNavList() {
      return [
        ROUTE_NAMES.gaugeEdit,
        ROUTE_NAMES.measureAddApartment,
        ROUTE_NAMES.cooperativeApartmentAll,
        ROUTE_NAMES.measureAddCoop,
        ROUTE_NAMES.cooperativePersonsAll,
      ].includes(this.$route.name);
    },
    changeBackgroundColor() {
      return [
        ROUTE_NAMES.login,
        ROUTE_NAMES.onBoarding,
        ROUTE_NAMES.activate,
        ROUTE_NAMES.county,
        ROUTE_NAMES.resetPassword,
      ].includes(this.$route.name);
    },
    fullWidth() {
      return [
        ROUTE_NAMES.gaugeEdit,
        ROUTE_NAMES.measureAddApartment,
        ROUTE_NAMES.measureAddCoop,
        ROUTE_NAMES.cooperativeApartmentAll,
        ROUTE_NAMES.cooperativePersonsAll,
        ROUTE_NAMES.login,
        ROUTE_NAMES.activate,
        ROUTE_NAMES.resetPassword,
      ].includes(this.$route.name);
    },
  },
};
</script>
